import {
    BaseScoreResult,
    QuestionnaireResponse,
    getAnswerCode,
    findItemByLinkId
} from './types';

export interface EpworthScoreResult extends BaseScoreResult {
    totalScore: number;
    excessiveSleepiness: boolean;
    details: Record<string, number>;
}


export function processEpworthQuestionnaire(response: QuestionnaireResponse): EpworthScoreResult {
    const rootItems = response.item || [];

    const scoringLinkIds = [
        'sitting-reading',
        'watching-tv',
        'sitting-inactive-public-place',
        'driving-car-passenger',
        'lying-down-afternoon',
        'sitting-talking',
        'sitting-calmly-after-lunch',
        'driving-car-stopped'
    ];

    const details: Record<string, number> = {};

    scoringLinkIds.forEach(linkId => {
        const item = rootItems.find(item => item.linkId === linkId);
        const code = getAnswerCode(item);

        if (code !== undefined) {
            const score = parseInt(code, 10);
            details[linkId] = isNaN(score) ? 0 : score;
        } else {
            details[linkId] = 0;
        }
    });

    const totalScore = Object.values(details).reduce((sum, score) => sum + score, 0);

    const excessiveSleepiness = totalScore >= 10;

    return {
        questionnaireId: response.questionnaire?.split('/')?.[1],
        questionnaireResponseId: response.id,
        totalScore,
        excessiveSleepiness,
        details
    };
}
